import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { ROLE_LABELS } from "@/lib/auth";

export default function Residents() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/users").then(r => setUsers(r.data)); }, []);
  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Residents & Team</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Who's who.</h1>
      </header>
      <Card className="bg-[#141414] border-zinc-800 p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-zinc-500 text-xs font-mono uppercase">
              <th className="py-2 pr-4">Name</th><th className="py-2 pr-4">Email</th>
              <th className="py-2 pr-4">Role</th><th className="py-2 pr-4">Unit</th>
              <th className="py-2 pr-4">Phone</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {users.map(u => (
              <tr key={u.id}>
                <td className="py-2 pr-4">{u.name}</td>
                <td className="py-2 pr-4 font-mono text-xs">{u.email}</td>
                <td className="py-2 pr-4">{ROLE_LABELS[u.role] || u.role}</td>
                <td className="py-2 pr-4 font-mono">{u.unit_number || "—"}</td>
                <td className="py-2 pr-4 font-mono text-xs">{u.phone || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
